<script lang="ts" setup>
import HeaderNav from '@/components/app/nav/HeaderNav.vue'
</script>

<template>
  <HeaderNav />
</template>

<style lang="scss">
@use "@sass/default_layout";
</style>
